module.exports = __webpack_public_path__ + "static/media/okladka-slownik.d70e93e7.webp";